import { authHttpClient, httpClient } from "./client";
import { type AccountInfo, accountInfoSchema } from "./models";

export const apiClient = {
  auth: {
    signin: async (accessToken: string) => {
      const config = authHttpClient.getConfig();
      const headers = {
        ...config.headers,
        Authorization: `Bearer ${accessToken}`,
      };

      await authHttpClient.instance.get("/auth/signin", { headers });
    },
    signinWithOrg: async (orgnr: number) => {
      const config = authHttpClient.getConfig();
      const headers = {
        ...config.headers,
      };

      const url = `/auth/signin/${orgnr}`;

      await authHttpClient.instance.get(url, { headers });
      await apiClient.auth.setupCsrfToken();
    },
    signOut: async () => {
      await authHttpClient.instance.get("/auth/signout");
    },
    getUserInfo: async (): Promise<AccountInfo> => {
      const response = await authHttpClient.instance.get("/auth/me");
      const data = response.data;
      // Set headers in both clients
      authHttpClient.instance.defaults.headers.common.csrf = data.csrfToken;
      httpClient.instance.defaults.headers.common.csrf = data.csrfToken;
      return accountInfoSchema.parse(data);
    },
    setupCsrfToken: async (): Promise<void> => {
      const response = await authHttpClient.instance.get("/auth/me");
      const data = response.data;
      // Set headers in both clients
      authHttpClient.instance.defaults.headers.common.csrf = data.csrfToken;
      httpClient.instance.defaults.headers.common.csrf = data.csrfToken;
    },
  },
};
